<!--
  This component copied from
  https://github.com/romainsimon/vue-simple-search-dropdown/blob/master/src/Dropdown.vue

  Changes added for our purposes:
    * Show dropdown only if list of options is not empty.
    * Add button to clear the input, `selectOption` method reworked to properly work when empty object passed.
    * Set 20 as default value for `maxItem`.
    * Styles updated.
    * Add `selectedDefault` property and watcher for it.

-->

<template>
  <div class="dropdown" v-if="options">

    <!-- Dropdown Input -->
    <input class="dropdown-input"
           :name="name"
           @focus="showOptions()"
           @blur="exit()"
           @keyup="keyMonitor"
           v-model="searchFilter"
           :disabled="disabled"
           :placeholder="placeholder"
    />
    <span v-show="searchFilter.length > 0" @click="selectOption({})" class="input-clear-button">
      <i class="fa fa-times"/>
    </span>

    <!-- Dropdown Menu -->
    <div class="dropdown-content"
      v-show="optionsShown && options.length > 0">
      <div class="dropdown-item"
           @mousedown="selectOption(option)"
           v-for="option in filteredOptions"
           :key="option.id"
      >
        {{ option.name || option.id || '-' }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      name: {
        type: String,
        required: false,
        default: 'dropdown',
        note: 'Input name'
      },
      options: {
        type: Array,
        required: true,
        default: [],
        note: 'Options of dropdown. An array of options with id and name',
      },
      placeholder: {
        type: String,
        required: false,
        default: 'Please select an option',
        note: 'Placeholder of dropdown'
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
        note: 'Disable the dropdown'
      },
      maxItem: {
        type: Number,
        required: false,
        default: 20,
        note: 'Max items showing'
      },
      selectedDefault: {
        type: Object,
        required: false,
        default: () => ({}),
        note: 'Initial selected value',
      },
    },
    data() {
      return {
        selected: {},
        optionsShown: false,
        searchFilter: ''
      }
    },
    created() {
      this.$emit('selected', this.selected);
    },
    computed: {
      filteredOptions() {
        const filtered = [];
        const regOption = new RegExp(this.searchFilter, 'ig');
        for (const option of this.options) {
          if (this.searchFilter.length < 1 || option.name.match(regOption)){
            if (filtered.length < this.maxItem) filtered.push(option);
          }
        }
        return filtered;
      }
    },
    methods: {
      selectOption(option) {
        this.selected = { ...option };
        this.optionsShown = false;
        if (option.id) {
          this.searchFilter = this.selected.name;
        } else {
          this.searchFilter = '';
        }
        this.$emit('selected', this.selected);
      },
      showOptions(){
        if (!this.disabled) {
          this.searchFilter = '';
          this.optionsShown = true;
        }
      },
      exit() {
        if (!this.selected.id) {
          this.selected = {};
          this.searchFilter = '';
        } else {
          this.searchFilter = this.selected.name;
        }
        this.$emit('selected', this.selected);
        this.optionsShown = false;
      },
      // Selecting when pressing Enter
      keyMonitor: function(event) {
        if (event.key === "Enter" && this.filteredOptions[0])
          this.selectOption(this.filteredOptions[0]);
      }
    },
    watch: {
      searchFilter() {
        if (this.filteredOptions.length === 0) {
          this.selected = {};
        } else {
          this.selected = this.filteredOptions[0];
        }
        this.$emit('filter', this.searchFilter);
      },
      selectedDefault() {
        this.selectOption(this.selectedDefault);
      }
    }
  };
</script>


<style scoped lang="scss" >
  @import '~scss/colors.scss';

  .dropdown {
    position: relative;
    display: block;
    margin: auto;

    .dropdown-input {
      background: #fff;
      cursor: pointer;
      border: 1px solid rgba(0,0,0,.15);
      border-radius: .2rem;
      color: $black-1;
      display: block;
      font-size: .875rem;
      padding: .25rem .5rem;
      height: 40px;
      line-height: 1.5;
      min-width: 350px;
      max-width: 350px;
      outline: none;
    }

    .dropdown-content {
      position: absolute;
      background-color: $white;
      min-width: 350px;
      max-width: 350px;
      max-height: 350px;
      border: 1px solid #e7ecf5;
      box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
      overflow: auto;
      z-index: 1;

      .dropdown-item {
        color: $black-0;
        font-size: .875rem;
        line-height: 1.5;
        padding: .25rem .5rem;
        text-decoration: none;
        display: block;
        cursor: pointer;
        &:hover {
          background-color: $gray-3;
        }
      }
    }

    .dropdown:hover .dropdowncontent {
      display: block;
    }

    .input-clear-button {
      position: absolute;
      left: 325px;
      top: 8px;
      z-index: 3;
      cursor: pointer;
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/SelectWithSearch.vue